import React from 'react'
import SignUp from '../../components /Signup/signup'

const signupPage = () => {
  return (
    <div>
      <SignUp />
    </div>
  )
}

export default signupPage
